// extracted by mini-css-extract-plugin
export var project = "project-mod--project--39TNT";
export var project__card = "project-mod--project__card--S6CVd";